export default "__VITE_ASSET__nXzfEnZG__"